export const CORNER_STYLES = [
  "after:hidden after:lg:block",
  "after:absolute after:w-6 after:h-6 after:rounded-full",
  "after:top-0 after:-left-3 after:translate-x-1/2 after:-translate-y-full after:rotate-85 after:shadow-corner-blue-base",

  "before:hidden before:lg:block",
  "before:absolute before:w-6 before:h-6 before:rounded-full",
  "before:bottom-0 before:-left-3 before:translate-x-1/2 before:translate-y-full before:rotate-180 before:shadow-corner-blue-base",
];
